const MEETING_STATUS = {
  pending: 'PENDING',
  planned: 'PLANNED',
  canceled: 'CANCELED',
};

export default MEETING_STATUS;
